import { SurveyAnswers, DiagnosticResult } from '../types/survey'

// IMPORTANTE: Substitua esta URL pela URL do seu Google Apps Script
const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzKESqHbwySMkYKjR62dFklpx65_Z9yBm8TFl-jMIoSqqSxy2Zl8jm5Qv1Nvz0xB-BY/exec'

export interface SubmissionData {
  answers: SurveyAnswers
  result: DiagnosticResult
}

export async function submitToGoogleSheets(
  data: SubmissionData,
): Promise<boolean> {
  try {
    const payload = {
      // Respostas do questionário
      q1: data.answers['q1'] || '',
      q2: data.answers['q2'] || '',
      q3: data.answers['q3'] || '',
      q4: data.answers['q4'] || '',
      q5: data.answers['q5'] || '',
      q6: data.answers['q6'] || '',
      q7: data.answers['q7'] || '',
      q8: data.answers['q8'] || '',
      q9: data.answers['q9'] || '',
      q10: data.answers['q10'] || '',
      q11: data.answers['q11'] || '',
      q12: data.answers['q12'] || '',
      q13: data.answers['q13'] || '',
      // Resultado do diagnóstico
      nivel: data.result.level,
      score: data.result.score,
    }

    const response = await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors', // Necessário para Google Apps Script
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })

    // Com mode: 'no-cors', não conseguimos ler a resposta, mas o envio funciona
    return true
  } catch (error) {
    console.error('Erro ao enviar para Google Sheets:', error)
    return false
  }
}
